import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_SINGLE_CLIENT_REPORT_ENTRIES = createAsyncActionType(
  "GET_SINGLE_CLIENT_REPORT_ENTRIES"
);

export const GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT = createAsyncActionType(
  "GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT"
);

export const SET_SINGLE_CLIENT_REPORT_ENTRIES_FILTERS =
  "SET_SINGLE_CLIENT_REPORT_ENTRIES_FILTERS";

export const SET_SINGLE_CLIENT_REPORT_ENTRIES_CURRENT_PAGE =
  "SET_SINGLE_CLIENT_REPORT_ENTRIES_CURRENT_PAGE";

export const GET_SINGLE_CLIENT_REPORT_DETAILS = createAsyncActionType(
  "GET_SINGLE_CLIENT_REPORT_DETAILS"
);

export const EXPORT_SINGLE_CLIENT_REPORT_PDF = createAsyncActionType(
  "EXPORT_SINGLE_CLIENT_REPORT_PDF"
);

export const CLEAR_SINGLE_CLIENT_REPORT_ENTRIES = createAsyncActionType(
  "CLEAR_SINGLE_CLIENT_REPORT_ENTRIES"
);

export const SET_TOGGLE_COLLAPSES_CLOSED_SINGLE_CLIENT_REPORT_DETAILS =
  "SET_TOGGLE_COLLAPSES_CLOSED_SINGLE_CLIENT_REPORT_DETAILS";

export const SET_COLLAPSE_ALL_SINGLE_CLIENT_REPORT_DETAILS =
  "SET_COLLAPSE_ALL_SINGLE_CLIENT_REPORT_DETAILS";

export const SET_EXPANDED_ROWS_LINKED_CLIENTS_SINGLE_CLIENT_REPORT =
  "SET_EXPANDED_ROWS_LINKED_CLIENTS_SINGLE_CLIENT_REPORT";

export const SET_ITEMS_PER_PAGE_SINGLE_CLIENT_REPORT =
  "SET_ITEMS_PER_PAGE_SINGLE_CLIENT_REPORT";

export const SET_COUNT_SINGLE_CLIENT_REPORT = "SET_COUNT_SINGLE_CLIENT_REPORT";
export const CLEAR_SINGLE_CLIENT_REPORT_PDF = "CLEAR_SINGLE_CLIENT_REPORT_PDF";
export const SET_NO_ENTRIES_MESSAGE_SINGLE_CLIENT_REPORT =
  "SET_NO_ENTRIES_MESSAGE_SINGLE_CLIENT";



// WEBPACK FOOTER //
// ./src/features/reports/types/singleClientReportTypes.js